import { LineItem } from "@repo/components";
import cx from "classnames";

const OrderSummary = ({ t, orderId, lineItems, isShippable }) => {
  const containerClasses = cx("mt-4 border", {
    "border-[#C62828] bg-[#FAEAEA]": !isShippable,
    "border-supportiveDarkGray bg-white": isShippable,
  });
  const headerClasses = cx(
    "flex items-center border-b p-4 text-start font-heading text-sm font-medium md:text-xl rtl:font-arabic",
    {
      "border-[#C62828]": !isShippable,
      "border-supportiveDarkGray": isShippable,
    }
  );

  return (
    <div className={containerClasses}>
      <h2 className={headerClasses}>
        {t("Order_Summary")}
        <span className="border-supportiveDarkGray bg-supportiveThinGray font-body ms-auto inline-block border p-1 text-sm">
          {t("Order_ID")}: #{orderId}
        </span>
      </h2>
      <div className="px-4">
        {lineItems?.map((item) => (
          <LineItem key={item?.id} item={item} isShippable={isShippable} />
        ))}
      </div>
    </div>
  );
};

export default OrderSummary;
